import React, { useEffect, useState } from 'react';
import { Navigate, useNavigate, useLocation } from 'react-router-dom';
import { PagesRoutes } from './PagesRoutes';
import Authentication from '../authentication/authentication';
import Layout from '../components/shared/Layout/Layout';
import { connect } from 'react-redux';
import { dispatch, RootState } from '../state/store/store';
import { authenticationSelectors } from '../state/ducks/authentication/selectors';
import { userSelectors } from '../state/ducks/user/selectors';
import Loader from '../components/shared/SmallComponents/Loader';
import { headerSelectors } from '../state/ducks/header/selectors';
import { drawers } from '../state/ducks/header/header';
import { mobileCheck } from '../utils/loadScript';

const AuthRoute = ({
    token,
    refreshToken,
    refreshTokenError,
    component: Component,
    companySettings,
    printMode,
    setPrintMode,
    featureFlags,
    setDrawerOpen,
    isDrawerOpen
}: any) => {
    const location = useLocation();
    const navigate = useNavigate();
    
    let loginRefer = PagesRoutes.Login;
    if (location.pathname !== '/') {
        loginRefer += `?refer=${encodeURIComponent(location.pathname + location.search)}`;
    }
    
    useEffect(() => {
        if (!token) refreshToken();
    }, [token, refreshTokenError]);
    
    const [lastHistoryLocation, setLastHistory] = useState('');
    useEffect(() => {
        // For now, just set the pathname
        setLastHistory(location.pathname);
    }, [isDrawerOpen, setDrawerOpen, location]);
    
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    if (urlParams.getAll('printMode').length > 0) {
        setPrintMode();
    }
    
    // Handle authentication redirects
    if (!token && refreshTokenError) {
        return <Navigate to={loginRefer} />;
    }
    
    // Handle authenticated rendering
    if (token) {
        Authentication.SetToken(token);
        return (
            <Layout printMode={printMode} featureFlags={featureFlags}>
                {!companySettings ? <Loader /> : <Component />}
            </Layout>
        );
    }
    
    // While checking authentication
    return null;
};

const mapStateToProps = (state: RootState) => ({
    token: authenticationSelectors.token(state),
    refreshTokenError: !!state.error.effects.authentication.refreshToken,
    companySettings: userSelectors.userInfo(state).companySettings,
    printMode: headerSelectors.printMode(state),
    featureFlags: userSelectors.featureFlags(state),
    isDrawerOpen: headerSelectors.drawerOpen(state)
});
const mapDispatchToProps = (dispatch: any) => ({
    refreshToken: dispatch.authentication.refreshToken,
    setPrintMode: () => dispatch.header.setPrintMode(true),
    setDrawerOpen: (open: drawers, params?: any) => dispatch.header.setDrawerOpenParams({ open, params }),
});

export default connect(mapStateToProps, mapDispatchToProps)(AuthRoute);
